export default __webpack_public_path__ + "static/media/sandDude.9f67a134.jpg";